import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
  }

  toggle() {
    this.setState((s) => ({ open: !s.open }));
  }

  close() {
    this.setState({ open: false });
  }

  render() {
    const { open } = this.state;
    return (
      <header className="sticky top-0 z-50 bg-bg-base/85 backdrop-blur border-b border-border-subtle">
        <nav className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/" onClick={this.close} className="text-ink-primary font-semibold tracking-wide text-sm sm:text-base hover:text-accent transition-colors">
            STIVAN <span className="text-accent">KITCHOUKOV</span>
          </Link>

          <button
            type="button"
            aria-label="Toggle navigation"
            onClick={this.toggle}
            className="md:hidden text-ink-secondary hover:text-accent p-2"
          >
            <i className={`fa ${open ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>

          <ul className="hidden md:flex items-center gap-8 text-sm">
            <li>
              <NavLink exact to="/" activeClassName="text-accent" className="text-ink-secondary hover:text-accent transition-colors">Home</NavLink>
            </li>
            <li>
              <NavLink to="/Portfolio" activeClassName="text-accent" className="text-ink-secondary hover:text-accent transition-colors">My Work</NavLink>
            </li>
            <li>
              <NavLink to="/Contact" activeClassName="text-accent" className="text-ink-secondary hover:text-accent transition-colors">Contact</NavLink>
            </li>
          </ul>
        </nav>

        {open && (
          <ul className="md:hidden border-t border-border-subtle bg-bg-base px-4 py-3 flex flex-col gap-3 text-sm">
            <li><NavLink exact to="/" onClick={this.close} activeClassName="text-accent" className="text-ink-secondary hover:text-accent">Home</NavLink></li>
            <li><NavLink to="/Portfolio" onClick={this.close} activeClassName="text-accent" className="text-ink-secondary hover:text-accent">My Work</NavLink></li>
            <li><NavLink to="/Contact" onClick={this.close} activeClassName="text-accent" className="text-ink-secondary hover:text-accent">Contact</NavLink></li>
          </ul>
        )}
      </header>
    );
  }
}

export default Header;
